import { Card, CardBody, Col } from 'reactstrap'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader'
import { HTMLModeTitle } from '../../../../Utils/Constants'
import { htmlData } from '../../../../Data/MiscellaneousData/EditorsData';
import { Highlight, themes } from 'prism-react-renderer';

export default function HtmlMode() {
    return (
        <Col xl={6}>
            <Card>
                <CommonCardHeader headClass='pb-0' title={HTMLModeTitle} />
                <CardBody>
                <Highlight theme={themes.vsDark} code={htmlData} language="HTML">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
                </CardBody>
            </Card>
        </Col>
    )
}
